import axios from 'axios'
import getSign from '../js/GetSgin'
import store from '@/store'
import { ElLoading, ElMessage } from 'element-plus'

// 注册系统
// 导出一个名为post1的函数，用于发送post请求
// 导出一个名为post1的函数，用于发送post请求
export function post1(type, url, data, callback, isLoading = true, countTime = 0) {
    // 节流
    if (countTime != 0) {
        // 获取本地存储中的时间
        let localSCTime = localStorage.getItem("postAntiShakeHYXTime");
        // 如果本地存储中没有时间，则设置时间
        if (!localSCTime) {
            localStorage.setItem("postAntiShakeHYXTime", countTime);
            // 设置定时器，在countTime秒后清除本地存储中的时间
            setTimeout(() => { localStorage.removeItem("postAntiShakeHYXTime"); }, countTime * 1000);
        } else {
            // 如果本地存储中有时间，则返回false
            return false;
        }
    }
    // let needRecordPostArr = ['/api/sms/public/code', '/api/sms/code', '/api/rf/login/'];
    // needRecordPostArr.forEach(val => {
    //     if (url.includes(val) ) {
    //         console.log(val);
    //         postRecord({'page': window.location.href, 'action': url, 'remark': store.state.RecordNumber });
    //     }
    // })

    // 如果isLoading为true，则显示loading
    let loadingInstance = null
    if (isLoading) {
        loadingInstance = ElLoading.service({ lock: true, background: 'rgba(0, 0, 0, .5)' })
    }
    // 设置请求的基础URL
    let productionBaseUrl = 'https://wpre.xapi.77qr.com';

    // 添加时间戳，防止缓存
    const timestamp = new Date().getTime();
    const timestampParam = { t: timestamp };

    // 合并参数
    const paramsWithTimestamp = type == 'get' ? { ...data, ...timestampParam } : timestampParam;

    // 发送post请求
    axios({
        baseURL: productionBaseUrl,
        url,
        method: type,
        headers: {
            'X-Access-Key': "AIGWObuQU",
            'sign': getSign(data),
            'tk': store.state.TOKEN,
        },
        params: paramsWithTimestamp,
        data: data,
        timeout: 1000 * 10,
    }).then(res => {
        // 如果isLoading为true，则关闭loading
        if (loadingInstance) loadingInstance.close()
        // 执行回调函数
        callback(res)
    }).catch(err => {
        // 如果isLoading为true，则关闭loading
        if (loadingInstance) loadingInstance.close()
        // 打印错误信息
        console.log(err);
        // 显示错误信息
        ElMessage.error(err.message)
    })
}

// 导出一个名为postRecord的函数，用于发送post请求
export function postRecord(data) {
    // 定义生产环境的baseUrl
    let productionBaseUrl = 'https://pre.xapi.77qr.com';

    // 添加时间戳，防止缓存
    const timestamp = new Date().getTime();

    // 使用axios发送post请求
    axios({
        // 设置请求的baseUrl
        baseURL: productionBaseUrl,
        // 设置请求的url
        url: `/api/userAction/add/10917`,
        // 设置请求的方法为post
        method: 'post',
        // 设置请求的headers
        headers: {
            // 设置X-Access-Key为AIGWObuQU
            'X-Access-Key': "AIGWObuQU",
            // 设置sign为getSign(data)的返回值
            'sign': getSign(data),
            // 设置tk为store.state.TOKEN的值
            'tk': store.state.TOKEN,
        },
        // 设置请求的params，添加时间戳
        params: { ...data, t: timestamp },
        // 设置请求的data
        data: data,
        // 设置请求的超时时间为10秒
        timeout: 1000 * 10,
    }).then(res => {
        // 打印请求成功的返回值
        console.log(res);
    }).catch(err => {
        // 打印请求失败的错误信息
        console.log(err);
    })
}

// 官网接口
// 导出一个名为post2的函数，用于发送post请求
export function post2(type, url, data, callback, isLoading = true) {
    let loadingInstance = null
    if (isLoading) {
        loadingInstance = ElLoading.service({ lock: true, background: 'rgba(0, 0, 0, .5)' })
    }
    let productionBaseUrl = 'https://oss.seasonfair.cn';
    const timestamp = new Date().getTime();
    const timestampParam = { t: timestamp };
    const paramsWithTimestamp = type == 'get' ? { ...data, ...timestampParam } : timestampParam;
    axios({
        baseURL: productionBaseUrl,
        url,
        method: type,
        headers: {
            'Accept': "application/json, text/plain, */*",
            'Content-Type': "application/json",
        },
        params: paramsWithTimestamp,
        data: type == 'post' ? data : {},
        timeout: 1000 * 30,
    }).then(res => {
        if (loadingInstance) loadingInstance.close()
        callback(res)
    }).catch(err => {
        if (loadingInstance) loadingInstance.close()
        console.log(err);
    })
}


// 查看文件是否存在接口
// 导出一个名为post3的函数，用于发送请求
export function post3(url, callback, data = {}, type = 'get') {
    // 定义生产环境的baseUrl
    let productionBaseUrl = 'https://season-share.7-event.cn/KerryAssest/p10602/';

    // 添加时间戳，防止缓存
    const timestamp = new Date().getTime();

    // 使用axios发送请求
    axios({
        // 设置请求的基础url
        baseURL: productionBaseUrl,
        // 设置请求的url
        url,
        // 设置请求的方法
        method: type,
        // 设置请求的头部信息
        headers: {
            'Accept': "application/json, text/plain, */*",
            'Content-Type': "application/json",
        },
        // 如果请求方法是get，则将data和时间戳作为参数传递
        params: type == 'get' ? { ...data, t: timestamp } : { t: timestamp },
        // 如果请求方法是post，则将data作为请求体传递
        data: type == 'post' ? data : {},
        // 设置请求的超时时间
        timeout: 1000 * 30,
    }).then(res => {
        // 请求成功后，调用回调函数
        callback(res)
    }).catch(err => {
        // 请求失败后，打印错误信息
        console.log(err);
    })
}